export function errorMessageAdd(message: string) {
    const errorMessageUl = document.querySelector('ul.gbp-error-message') as HTMLElement;
    const liItem = document.createElement('li');
    liItem.textContent = message;
    errorMessageUl.appendChild(liItem);
}
export function errorMessageClear() {
    const errorMessageUl = document.querySelector('ul.gbp-error-message') as HTMLElement;
    errorMessageUl.innerHTML = ''
}
